module.exports = {
    LINK:           'link',
    IMAGE:          'image',
    FOOTNOTE_REF:   'footnote-ref',
    HARD_BREAK:     'hard_break',

    // GitBook specifics
    MATH:           'math',
    TEMPLATE:       'template'
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/constants/entities.js
// module id = 193
// module chunks = 0